import React, { Fragment } from "react";
import {
  Navbar,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

export default class HRNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }
  render() {
    return (
      <Fragment>
        <Navbar
          container
          className="navbar navbar-expand-lg   navbar-dark "
          expand="md"
        >
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav vertical className="ml-auto" navbar>
              <NavItem>
                <NavLink href="/hr/attendance">Attendance</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/hr/attendance/project">Report</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/hr/attendancesummery">Summery Report</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </Fragment>
    );
  }
}
